













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Spinner } from 'vue-image-spinner2';
import _ from 'lodash';
import { mapState } from 'vuex';
import EcommerceDetailModal from '../modals/ecommerceDetailModal.vue';

@Component({
    name: 'ecommerce',
    data: function () {
        return {
            ecommercePage_: 1,
        };
    },
    components: {
        EcommerceDetailModal,
        Spinner,
    },
    computed: {
        ...mapState('ecommerce', ['allEcommerce', 'allEcommerceLoading', 'ecommercePerPage', 'ecommercePage', 'ecommerceTotal']),
        ...mapState('ecommerce', {
            allEcommerce: (state: any) => {
                const allEcommerce = state.allEcommerce.map((ecommerce: any) => {
                    return {
                        ...ecommerce,
                    };
                });
                return _.orderBy(allEcommerce, 'id', 'asc');
            },
        }),
    },
})
export default class Ecommerce extends Vue {
    private currentUser!: any;
    public allEcommerceLoading!: any;
    private allEcommerce!: any;
    public ecommerce_word_search: any = '';
    public ecommercePage_!: any;
    private activeEcommerceLoaded: boolean = false;

    allEcommerceHeaders = [
        { thClass: 'th', key: 'id', label: 'No. Sección' },
        { thClass: 'th', key: 'title', label: 'Título' },
        { thClass: 'th', key: 'status', label: 'Activa' },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    setUrlSearch(search: string) {
        // @ts-ignore
        search = search.trim();
        this.$router.push({
            path: 'ecommerce',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    @Watch('$route')
    getAllEcommerce() {
        this.$store.dispatch('ecommerce/getAll', {});
    }
    onEditEcommerce(id: number) {
        this.$store.dispatch('ecommerce/getOne', id);
        this.activeEcommerceLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('ecommerce-detail-modal');
        }, 400);
    }

    onOpenEcommerceDetailModal(id: number | null = null) {
        this.$store.dispatch('ecommerce/getOne', id);
        this.activeEcommerceLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('ecommerce-detail-modal');
        }, 400);
    }

    onToggleStatus(event: any, id: any, status: any) {
        let data = {
            id: id,
            status: event,
        };
        this.$store.dispatch('ecommerce/postOne', {
            ecommerce: { data: data, vm: this },
        });
    }

    mounted() {
        this.getAllEcommerce();
        this.ecommercePage_ = 1;
    }
}
